jQuery(function ($) {

  $(document).ready(function () {
    $('.promo-cards').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      fade: true,
      cssEase: 'linear',
      arrows: false,
      dots: false,
    });
  });

});